import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungUlm() {
  return (
    <CityPageTemplate
      city="Ulm"
      slug="ulm"
      intro="In der Stadt mit dem höchsten Kirchturm der Welt sollte auch Deine Finanzplanung neue Höhen erreichen."
      description="Unabhängige & digitale Finanzberatung für Ulm: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
